<script>
    import { goto } from "$app/navigation";
    import sheild_checkmark from "$lib/assets/images/icons/sheild_checkmark.svg";
    import map_marker from "$lib/assets/images/icons/map_marker.svg";
    import bell_notification from "$lib/assets/images/icons/bell_notification.svg";
    export let btnColor = "variant-filled-secondary";
    import { focusForm } from "$lib/stores/store";
    function handleClick() {
        // if form is on page scroll to it, otherwise go to order page
        const formField = document.querySelector(".form-container");

        if (formField) {
            formField.scrollIntoView({ behavior: "smooth", block: "center" });
            $focusForm = true;
            console.log("focusForm: ", $focusForm);
            // formField.focus();
        } else {
            goto("/order");
        }
    }
</script>

<section>
    <div class="container">
        <div class="header">
            <h2>We're here for you.</h2>
            <p>Your car may look good on the outside, it's hard to know what's going on beneath the surface. But with a C2 inspection certification, we do. That’s how we cover what WILL happen, not what MIGHT happen.</p>
        </div>

        <div class="cards">
            <div class="card-container">
                <div class="card">
                    <div class="card-header">
                        <img src={sheild_checkmark} alt="checkmark" />
                    </div>
                    <div class="card-text">
                        <h3>Certified Vechicle Inspection</h3>
                        <p>Our world class vehicle inspectors review and certify every vital component.</p>
                    </div>
                </div>
            </div>

            <div class="card-container">
                <div class="card">
                    <div class="card-header">
                        <img src={map_marker} alt="checkmark" />
                    </div>
                    <div class="card-text">
                        <h3>Let us do the leg work</h3>
                        <p>Our team will inspect the vehicle anywhere in the U.S. saving you time and money.</p>
                    </div>
                </div>
            </div>

            <div class="card-container">
                <div class="card">
                    <div class="card-header">
                        <img src={bell_notification} alt="checkmark" />
                    </div>
                    <div class="card-text">
                        <h3>Concierge Claim Support</h3>
                        <p>When you need help, you well... need help, Thats why we prioritize a speedy claims process.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer">
            <button class="btn btn-lg {btnColor} text-white" on:click={handleClick}>Get Started</button>
        </div>
    </div>
</section>

<style>
    section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        margin-bottom: 0;
        max-width: 1400px;
        margin: 2rem auto;
    }

    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2rem;
        padding: 2rem 0;
        margin-bottom: 0;
    }

    .header {
        @apply text-center;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        margin-bottom: 0;
    }
    .header h2 {
        color: var(--blue, #272d5b);
        text-align: center;
        font-family: Inter;
        font-size: 40px;
        font-style: normal;
        font-weight: 800;
        line-height: 42px;
    }

    .header p {
        @apply text-lg;
        color: var(--blue, #272d5b);
        max-width: 774px;
        padding: 0 2rem;
        text-align: center;
        font-family: Inter;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 120% */
    }

    .cards {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        margin-bottom: 0;
    }

    .card-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2rem;
        padding: 0 2rem;
        margin-bottom: 0;
        border: none;
    }

    .card {
        @apply bg-white p-4 text-center;
        border: 0px solid white;
        box-shadow: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        margin-bottom: 0;
        width: 100%;
    }

    .card-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100px;
        gap: 1rem;
        margin-bottom: 0;
    }

    .card-text {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        margin-bottom: 0;
    }
    .card-text h3 {
        color: #000;

        text-align: center;
        /* h3 */
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
    }

    .card-text p {
        color: #000;

        text-align: center;
        /* p */
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
    }

    .footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2rem;
        margin-bottom: 0;
    }
    button {
        display: flex;
        width: 360px;
        padding: 15px 20px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        color: #fff;

        font-family: Inter;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
    }
    @media screen and (min-width: 768px) {
        .cards {
            flex-direction: row;
            gap: 0rem;
        }

        .card-container {
            max-width: 33.333%;
            overflow: hidden;
            padding: 0;
        }
    }
</style>
